export const SPORTIF_MARK =
  '<circle cx="12" cy="12" r="8.5" fill="none" stroke="currentColor" stroke-width="2"/>' +
  '<path d="M12 8.6l3.2 2.35-1.2 3.8h-4l-1.2-3.8z" fill="currentColor"/>' +
  '<path d="M12 8.6V3.5M15.2 10.95l4.9-1.6M14 14.75l3 4.1M10 14.75l-3 4.1M8.8 10.95l-4.9-1.6" stroke="currentColor" stroke-width="1.6"/>';

export const SPRINT_ICON =
  '<path d="M2 8h5M1 12h7M2 16h5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
  '<path d="M10 6l6 6-6 6M15 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>';
